import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { ChevronDown } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1773724158149-2458726e66a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxob3QlMjBhaXIlMjBiYWxsb29uJTIwdGVvdGlodWFjYW58ZW58MHx8fHwxNzg2MjE4MjY5fDA&ixlib=rb-4.1.0&q=85";

const HERO_VIDEO = "/hero_lite.mp4";

export default function Hero() {
  const { t, lang } = useLang();
  return (
    <section data-testid="hero-section" className="relative min-h-[100svh] w-full overflow-hidden">
      <img
        src={HERO_IMG}
        alt={lang === "es" ? "Pirámides de Teotihuacán al amanecer" : "Teotihuacán pyramids at sunrise"}
        fetchPriority="high"
        className="absolute inset-0 w-full h-full object-cover object-center scale-[1.02]"
      />
      <video
        data-testid="hero-video"
        src={HERO_VIDEO}
        poster={HERO_IMG}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        className="absolute inset-0 w-full h-full object-cover object-center scale-[1.02]"
      />
      <div className="absolute inset-0 hc-gradient-overlay" />
      <div className="absolute inset-0 hc-noise opacity-40" />

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12 min-h-[100svh] flex flex-col justify-end pb-28 md:pb-36">
        <div className="max-w-4xl">
          <p className="eyebrow mb-6 reveal in">{t("hero.kicker")}</p>
          <h1 className="font-serif-hc font-light text-white leading-[0.95] tracking-tight text-5xl sm:text-6xl md:text-7xl lg:text-[100px] reveal in uppercase">
            {t("hero.title_a")}
            <br />
            <span className="italic normal-case text-[#C4A661]">{t("hero.title_b")}</span>
          </h1>
          <p className="mt-8 max-w-xl text-lg md:text-xl text-[#F5F2EA]/85 font-light leading-relaxed">
            {t("hero.sub")}
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link to="/tours" data-testid="hero-cta-tours" className="hc-btn-primary">
              {t("hero.cta_primary")}
            </Link>
            <Link to="/reservar" data-testid="hero-cta-book" className="hc-btn-secondary">
              {t("hero.cta_secondary")}
            </Link>
          </div>
          <p data-testid="hero-trustline" className="mt-8 text-[11px] tracking-[0.3em] uppercase text-[#F5F2EA]/60">
            {t("hero.trustline")}
          </p>
        </div>

        <div className="absolute bottom-8 right-8 hidden md:flex flex-col items-center gap-2 text-[#F5F2EA]/70">
          <span className="eyebrow !text-[#F5F2EA]/70">{t("hero.scroll")}</span>
          <ChevronDown size={18} className="animate-bounce" />
        </div>
      </div>
    </section>
  );
}
